// Helper function that builds Headers for api calls.
export const buildStandardHeaders = authorizationHeader => ({
  'Access-Control-Allow-Origin': '*',
  Authorization: authorizationHeader,
});
